import { connect } from 'dva';
import { createForm } from 'rc-form';
import { MFAModal } from './MFA';
import { routerRedux } from 'dva/router';

export const mapStateToProps = (state, ownProps) => {
  const { authentication, loading } = state;
  const { mfaModal, mfaCallback } = authentication;
  const isLoading = loading.effects['authentication/verifyMFA']
  return {
    mfaModal,
    mfaCallback,
    isLoading,
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    redirect(pathname) {
      dispatch(routerRedux.push({ pathname: `${pathname}` }));
    },
    verifyMFA(otp){
        dispatch({ type : 'authentication/verifyMFA', payload: otp })
    },
    closeModal() {
      dispatch({
        type: 'authentication/save',
        payload: { mfaModal: false, mfaCallback: () => {} }
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(createForm()(MFAModal));
